// extracted by mini-css-extract-plugin
export default {"wrapper":"Friends_wrapper__4H0IP"};